import axios, { AxiosRequestConfig } from 'axios';

import { AnonymousUser } from '../types';
import { DataResponse } from '../types/api';

const URL = '/v2/public/users';

class AnonymousUserService {
  static findByUuid(
    uuid: string,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AnonymousUser>> {
    return axios.get(`${URL}/${uuid}`, config);
  }

  static create(
    data: AnonymousUser,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AnonymousUser>> {
    return axios.post(URL, data, config);
  }

  static update(
    uuid: string,
    data: AnonymousUser,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AnonymousUser>> {
    return axios.patch(`${URL}/${uuid}`, data, config);
  }
}

export { AnonymousUserService };
